var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container collectDetail" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "我的收藏", url: "/system/collect" },
                { label: "收藏夹详情", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "collectDetail-top" }, [
        _c("div", { staticClass: "collectDetail-top-title" }, [
          _vm._v(_vm._s(_vm.favoriteName))
        ]),
        _c("div", { staticClass: "collectDetail-top-desc" }, [
          _vm._v(_vm._s(_vm.favoriteDesc))
        ]),
        _c("div", { staticClass: "collectDetail-top-time" }, [
          _c("span", { staticStyle: { "margin-right": "10px" } }, [
            _vm._v(_vm._s(_vm.updatedTime))
          ]),
          _vm._v(" " + _vm._s((_vm.total || 0) + " 条内容") + " ")
        ]),
        _c("div", { staticClass: "collectDetail-top-option" }, [
          _c(
            "div",
            {
              staticClass: "collectDetail-top-option-edit",
              on: { click: _vm.editCollectDialog }
            },
            [
              _c("img", {
                staticClass: "collectDetail-top-option-edit-img",
                attrs: { src: require("@/assets/editGray.png") }
              }),
              _c("div", [_vm._v("编辑")])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "collectDetail-top-option-delete",
              on: { click: _vm.delCollect }
            },
            [
              _c("i", {
                staticClass: "el-icon-delete",
                staticStyle: { "font-size": "14px", "margin-right": "2px" }
              }),
              _c("div", [_vm._v("删除")])
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "collectDetail-bottom" }, [
        _c("div", { staticClass: "collectDetail-bottom-top" }, [
          _vm._v(" " + _vm._s((_vm.total || 0) + "个内容") + " ")
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listMask,
                expression: "listMask"
              }
            ],
            staticClass: "collectDetail-bottom-list"
          },
          _vm._l(_vm.instList, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "collectDetail-bottom-list-item" },
              [
                _c(
                  "div",
                  { staticClass: "collectDetail-bottom-list-item-left" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "collectDetail-bottom-list-item-left-title",
                        on: {
                          click: function($event) {
                            return _vm.toInst(item)
                          }
                        }
                      },
                      [
                        _c("div", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(item.title))
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "collectDetail-bottom-list-item-left-title-systemName"
                          },
                          [_vm._v(" " + _vm._s(item.systemName) + " ")]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "collectDetail-bottom-list-item-left-public"
                      },
                      [
                        item.itemColumnList[0]
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collectDetail-bottom-list-item-left-public-org"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(item.itemColumnList[0]) + " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "collectDetail-bottom-list-item-left-public-org"
                          },
                          [_vm._v(" " + _vm._s(item.itemColumnList[1]) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "collectDetail-bottom-list-item-left-public-time"
                          },
                          [_vm._v(" " + _vm._s(item.itemColumnList[2]) + " ")]
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "el-popconfirm",
                  {
                    attrs: { title: "确定取消收藏吗？" },
                    on: {
                      onConfirm: function($event) {
                        return _vm.cancelCollect(item)
                      },
                      onCancel: function($event) {
                        ""
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "collectDetail-bottom-list-item-right",
                        attrs: { slot: "reference" },
                        slot: "reference"
                      },
                      [_c("collect-fill-icon"), _vm._v(" 取消收藏 ")],
                      1
                    )
                  ]
                )
              ],
              1
            )
          }),
          0
        ),
        _c("div", { staticClass: "footer-page" }, [
          _c(
            "div",
            { staticClass: "footer-right" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  "current-page": _vm.pageNum,
                  "page-sizes": [10, 20, 50, 100, 1000, 2000],
                  "hide-on-single-page": false
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "current-change": _vm.currentChange,
                  "size-change": _vm.sizeChange
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "550px",
            height: "400px",
            title: "编辑收藏夹",
            visible: _vm.ifShowEditDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowEditDialog = $event
            }
          }
        },
        [
          _c("collect-edit-dialog", {
            attrs: {
              "if-edit-collect": _vm.ifEditCollect,
              "collect-item": _vm.editCollect
            },
            on: { submitCollectFn: _vm.submitCollectFn }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "600px",
            height: "400px",
            title: "删除收藏夹",
            visible: _vm.ifShowDelDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowDelDialog = $event
            }
          }
        },
        [
          _c("collect-del-dialog", {
            attrs: { "favorites-id": _vm.id },
            on: { delCollectFn: _vm.delCollectFn }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }